import { bl_fi_my_einvoice_gen_doc_to_irb_submission_queue_RowClass } from '../../dbschema/bl_fi_my_einvoice_gen_doc_to_irb_submission_queue.model';
import { BaseContainerModel } from '../base-container.model';

export class MyEInvoiceGenDocToIRBSubmissionQueueContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_gen_doc_to_irb_submission_queue: bl_fi_my_einvoice_gen_doc_to_irb_submission_queue_RowClass = new bl_fi_my_einvoice_gen_doc_to_irb_submission_queue_RowClass();
}
